module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_header_m-86607e2f2e8423b475606932ce1c3a95.jpg";